import React from "react";
import "./Education.scss";
import EducationCard from "../../components/educationCard/EducationCard";
import usePortfolioContent from "../../hooks/usePortfolioContent";

export default function Education() {
  const {educationInfo} = usePortfolioContent();
  if (educationInfo.display) {
    return (
      <section className="education-section" id="education" aria-label="Education">
        <h2 className="education-heading">Education</h2>
        <div className="education-card-container">
          {educationInfo.schools.map((school, index) => (
            <EducationCard key={index} school={school} />
          ))}
        </div>
      </section>
    );
  }
  return null;
}
